module.exports = __webpack_public_path__ + "img/product_119.3903893.svg";